import { Spin } from "antd";
import "../../styles/Spin.css";
const StaticSpin = () => {
    return (
        <div className="Spin">
            <Spin size="large">
                <div></div>
            </Spin>
        </div>
    );
};
export default StaticSpin;